import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import { KeyValueErrors } from 'shared/library/use-api';
import { User } from 'shared/@types';
import {
  getInitialOnboardingUserSetupData,
  OnboardingUserSetupData,
} from 'shared/library/onboarding-user-setup';

export interface OnboardingWizardSupport {
  insurancePartnerName: string | null;
}

const defaultSupport: OnboardingWizardSupport = {
  insurancePartnerName: null,
};

const useOnboardingWizardStore = create(
  combine(
    {
      data: null as OnboardingUserSetupData | null,
      support: defaultSupport,
      errors: {} as KeyValueErrors,
    },
    (set) => ({
      setup: (user: User, support: OnboardingWizardSupport = defaultSupport) => {
        set({
          data: getInitialOnboardingUserSetupData(user),
          support,
        });
      },
      reset: () =>
        set({
          data: null,
          support: defaultSupport,
          errors: {},
        }),
      setData: (newData: Partial<OnboardingUserSetupData>) => {
        set((state) => ({ data: { ...state.data!, ...newData } }));
      },
      setSupport: (newData: Partial<OnboardingWizardSupport>) => {
        set((state) => ({ support: { ...state.support, ...newData } }));
      },
    }),
  ),
);

export default useOnboardingWizardStore;
